import type { ReactNode } from 'react'

interface CompanyDetailLayoutProps {
  children: ReactNode
  sidePanel?: ReactNode
}

export function CompanyDetailLayout({
  children,
  sidePanel,
}: CompanyDetailLayoutProps) {
  return (
    <div className="h-full overflow-y-auto overflow-x-hidden">
      <div className="flex min-h-full min-w-0 items-stretch">
        <div className="min-w-0 flex-1">{children}</div>
        {sidePanel ? (
          <aside className="min-w-0 self-stretch">{sidePanel}</aside>
        ) : null}
      </div>
    </div>
  )
}
